import gsap from "gsap/dist/gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.arrive(".divani-poltrone", {existing: true}, function (){

  gsap.to(".img-divani-poltrone-container img", {
    duration: 1,
    scale: 1,
    scrollTrigger: {
      trigger: ".img-divani-poltrone-container",
      scrub: 1
    }
  })

  gsap.to(".divani-poltrone-container-floating-image img", {
    duration: 1,
    scale: 1,
    scrollTrigger: {
      trigger: ".divani-poltrone-container-floating-image",
      scrub: 1
    }
  })

  gsap.to(".text-progettazione-creazione", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-progettazione-creazione",
      start: 'top bottom',
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })

  gsap.to(".text-divani-poltrone", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-divani-poltrone",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })

  gsap.to(".img-container-poltrone img", {
    duration: 1,
    scale: 1,
    scrollTrigger: {
      trigger: ".img-container-poltrone",
      scrub: 1
    }
  })

  gsap.to(".text-poltrone-servizi h3", {
    x: 0,
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: ".text-poltrone-servizi",
      toggleActions: "restart none resume none"
    }
  })

})